import { render, staticRenderFns } from "./FamilyNode.vue?vue&type=template&id=0c8c4166&scoped=true"
import script from "./FamilyNode.vue?vue&type=script&lang=js"
export * from "./FamilyNode.vue?vue&type=script&lang=js"
import style0 from "./FamilyNode.vue?vue&type=style&index=0&id=0c8c4166&prod&lang=css"
import style1 from "./FamilyNode.vue?vue&type=style&index=1&id=0c8c4166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c4166",
  null
  
)

export default component.exports